


<div class="error-server-container">
    <div class="header">
    </div>
    <div class="left">
        <div class="container-left">
            <div class="text-information">{{message}}</div>
        </div>
    </div>
    <div class="right">
        <div class="imgs-container">
            <img class="oval" src="./assets/temporals/oval.png" alt="">
            <img class="think-boy" src="./assets/temporals/thinkBoy.png" alt="">
        </div>
    </div>
</div>